module.exports = __webpack_public_path__ + "static/media/V4-label.57808814.png";